import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

import { flattenDeep } from 'lodash-es';
import { from, Observable } from 'rxjs';
import { AuthCoreService, PolicyViewModel } from 'src/proxy';

@Injectable()
export class PolicyService {
  private policiesEnum: PolicyViewModel[] = [];
  private policies$: Observable<PolicyViewModel[]> = null;

  constructor(private authCoreService: AuthCoreService) {
    // this.loadPolicies();
  }

  get policies() {
    return this.policiesEnum;
  }

  hasPolicies() {
    return this.policiesEnum && this.policiesEnum.length > 0;
  }

  loadPolicies() {
    this.policies$ = from(this.authCoreService.getPolicies())
      .pipe(map(policies => this.policiesEnum = policies));
    return this.policies$;
  }

  getRolesFromPolicies(names: string[]): string[] {
    const claims: string[] = flattenDeep(this.policies.filter(p => names.includes(p.name))
      .map(p => p.requiredClaimValues));
    if (!claims) {
      return [];
    }
    return [...new Set(claims)];
  }


}


